import { Paper } from '@mui/material';
import { t } from 'i18next';
import { SEVERITY_COLORS, Severity, getLabel } from '../../../../common/enums/Severity';
import { SeverityChart } from '../../common/components/SeverityChart';
import { Issue } from '../models/valueObjects/Issue';

type Props = {
  groups: Record<Severity, Issue[]>;
};

export const IssuesChart = ({ groups }: Props) => {
  const chartData = [Severity.HIGH, Severity.MED, Severity.LOW, Severity.PASSED, Severity.FILTERED, Severity.NA, Severity.DISABLED].map((s) => ({
    name: getLabel(s),
    amount: groups[s].length,
    color: SEVERITY_COLORS[s].main,
    textColor: SEVERITY_COLORS[s].text,
    backgroundColor: SEVERITY_COLORS[s].background,
  }));

  return (
    <Paper>
      <SeverityChart title={t('issues')} items={chartData} layout="row" padding={2} />
    </Paper>
  );
};
